/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "The Friendship Hub",
      "Find New Friends With Bumble For Friends App | Bumble",
      "Download on the App Store",
      "Get it on Google Play",
      "A dedicated space to make new friends",
      "Discover people near you who are here for genuine connections.",
      "Find friends for all stages of life",
      "New to town? Need a fresh start? Your new crew is waiting for you!",
      "A safe space for everyone",
      "Welcome to a kind part of the internet, where you can be you.",
      "Download the app",
      "Meet IRL with people who share your interests!",
      "Get to know a new group of people with Plans on Bumble For Friends",
      "You’ve been invited to join Plans",
      "Plans is a new feature on Bumble For Friends where you can create and join group meetups with new friends near you",
      "Manage Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "dienos",
                  "dienų",
                  "dienoms",
                  "dienas",
                  "dienose",
                  "dienomis",
                  "dienos!"
            ],
            "plural": [
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų",
                  "dienų!"
            ],
            "singular": [
                  "diena",
                  "dienos",
                  "dienai",
                  "dieną",
                  "dienoje",
                  "diena",
                  "diena!"
            ]
      },
      "hour": {
            "few": [
                  "valandos",
                  "valandų",
                  "valandoms",
                  "valandas",
                  "valandose",
                  "valandomis",
                  "valandos!"
            ],
            "plural": [
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų",
                  "valandų!"
            ],
            "singular": [
                  "valanda",
                  "valandos",
                  "valandai",
                  "valandą",
                  "valandoje",
                  "valanda",
                  "valanda!"
            ]
      },
      "minute": {
            "few": [
                  "minutės",
                  "minučių",
                  "minutėms",
                  "minutes",
                  "minutėse",
                  "minutėmis",
                  "minutės!"
            ],
            "plural": [
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių",
                  "minučių!"
            ],
            "singular": [
                  "minutė",
                  "minutės",
                  "minutei",
                  "minutę",
                  "minutėje",
                  "minute",
                  "minute!"
            ]
      },
      "month": {
            "few": [
                  "mėnesiai",
                  "mėnesių",
                  "mėnesiams",
                  "mėnesius",
                  "mėnesiuose",
                  "mėnesiais",
                  "mėnesiai!"
            ],
            "plural": [
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių",
                  "mėnesių!"
            ],
            "singular": [
                  "mėnuo",
                  "mėnesio",
                  "mėnesiui",
                  "mėnesį",
                  "mėnesyje",
                  "mėnesiu",
                  "mėnesi!"
            ]
      },
      "second": {
            "few": [
                  "sekundės",
                  "sekundžių",
                  "sekundėms",
                  "sekundes",
                  "sekundėse",
                  "sekunde",
                  "sekundės!"
            ],
            "plural": [
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių",
                  "sekundžių!"
            ],
            "singular": [
                  "sekundė",
                  "sekundės",
                  "sekundei",
                  "sekundę",
                  "sekundėje",
                  "sekunde",
                  "sekunde!"
            ]
      },
      "year": {
            "few": [
                  "metai",
                  "metų",
                  "metams",
                  "metus",
                  "metuose",
                  "metais",
                  "metai!"
            ],
            "plural": [
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų",
                  "metų!"
            ],
            "singular": [
                  "metai",
                  "metų",
                  "metams",
                  "metus",
                  "metuose",
                  "metais",
                  "metai!"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
